import { requestGet } from "@/utils/dva16";
import { EGet, NMarket, RSetState } from "./contants";

export default {
	namespace: NMarket,
	state: {
		marketList: null,
		loading: false,
	},
	reducers: {
		[RSetState](state, { payload }) {
			return {
				...state,
				...payload,
			};
		},
	},
	effects: {
		async [EGet]({ payload, callback }, { call, reducer, select, effect }) {
			reducer(RSetState, { loading: true });
			let res = await requestGet("market", payload);
			reducer(RSetState, { marketList: res, loading: false });
		},
	},
};
